<!-- 企业认证列表 -->
<template>
  <div>
    <el-card class="box-card">
      <div class="text item">
        <el-row type="flex" justify="end">
          <el-col :span="3">
            <el-select v-model="statusVal" @change="getDataFn" placeholder="请选择">
              <el-option
                  v-for="item in statusData"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <div class="text item">
          <el-table style="width: 100%" :data="auditData" class="table-content">
            <el-table-column align="center" show-overflow-tooltip width="100" label="编号" :fit="true"
                             type="index"></el-table-column>
            <el-table-column align="center" show-overflow-tooltip width="190" label="企业名称"
                             prop="companyName"></el-table-column>
            <el-table-column align="center" show-overflow-tooltip width=120 label="创建人"
                             prop="createEmp"></el-table-column>
            <el-table-column align="center" label='发布时间' prop="createTime"></el-table-column>
            <el-table-column align="center" label='是否通过' :formatter="stateFormat" prop="approveStatus">
              <template slot-scope="scope">
                <el-tag :style="machineStatusStyle(scope.row.approveStatus,scope.row.checkStatus)"
                        v-if="scope.row.approveStatus == 1 || scope.row.checkStatus == 0" effect="dark">待审核
                </el-tag>
                <el-tag :style="machineStatusStyle(scope.row.approveStatus,scope.row.checkStatus)"
                        v-else-if="scope.row.approveStatus == 2 || scope.row.checkStatus == 1" effect="dark">已通过
                </el-tag>
                <el-tag :style="machineStatusStyle(scope.row.approveStatus,scope.row.checkStatus)"
                        v-else-if="scope.row.approveStatus == 3 || scope.row.checkStatus == 2" effect="dark">已拒绝
                </el-tag>
              </template>
            </el-table-column>

            <el-table-column label="操作" align="center" width="200">
              <template slot-scope="scope">
                <el-button v-if="scope.row.approveStatus == 2 || scope.row.checkStatus == 1"
                           @click="toParticulars(false,scope.row)" class="table-compile">详情
                </el-button>
                <!--                size="mini"-->
                <!--                size="mini"-->
                <el-button v-else type="primary" @click="shengpi(false,scope.row)" class="table-compile">审批
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagelist" style="text-align: center">
          <el-row type="flex" justify="center">
            <el-col :span="24" class="nomore" style="margin-top:24px;">
              <!-- <span v-if="isShow">没有更多了</span> -->
              <el-pagination
                  class="page"
                  background
                  :current-page="currentPage"
                  @current-change="current_page"
                  layout="total, prev, pager, next, jumper"
                  :total="dataNumber">
              </el-pagination>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dataNumber: 0,  // 有多少条数据
      currentPage: 1,  // 当前页
      statusVal: '', //1:待审核 2:已通过 3:已拒绝
      page: 1,
      size: 10,
      statusData: [],    // 类型数据
      bindStatusData: [    // 绑定
        {
          value: '',
          label: '全部'
        },
        {
          value: '0',
          label: '待审核'
        },
        {
          value: '1',
          label: '已通过'
        },
        {
          value: '2',
          label: '已拒绝'
        }
      ],
      elseStatusData: [    // 油田、企业、灵活、见习、个人
        {
          value: '',
          label: '全部'
        },
        {
          value: '1',
          label: '待审核'
        },
        {
          value: '2',
          label: '已通过'
        },
        {
          value: '3',
          label: '已拒绝'
        }
      ],
      auditData: [],   // 存放全部数据
    }
  },
  props: ['type', 'genre'],
  methods: {
    // 详情
    toParticulars(isShow, itemData) {
      this.$router.push({
        path: '/enterdetails',
        query: {
          params:JSON.stringify(itemData.id)
        }
      })
      // console.log('childItemData')
      // console.log(itemData)
      // this.$emit('statusFun', isShow, itemData)
    },

    // 审批
    shengpi(isShow, itemData){
      this.$router.push({
        path: '/entershenpi',
        query: {
          params:JSON.stringify(itemData.id)
        }
      })
      // console.log('childItemData')
      // console.log(itemData)
      // this.$emit('statusFun', isShow, itemData)
    },
    current_page(currentPage) {
      this.page = currentPage
      this.getDataFn()
    },
    getDataFn() {
      if (this.genre) {
        // for(let i=0){}

        this.axiosGet(`/web/userBinding/page?checkStatus=${this.statusVal}&page=${this.page}&size=${this.size}`).then((res) => {
          // console.log('个人绑定审核')
          // console.log(this.genre)
          // console.log(res)
          if (res.code == 200) {

            this.auditData = res.data.list
            this.dataNumber = res.data.total
            this.statusData = this.bindStatusData
            // console.log('个人')
            // console.log(this.auditData)
            // console.log(this.dataNumber)
          }
        })
      } else {
        this.axiosGet(`/web/companyApprove/page?approveStatus=${this.statusVal}&type=${this.type}&page=${this.page}&size=${this.size}`).then((res) => {
          if (res.code == 200) {
            this.auditData = res.data.list
            this.dataNumber = res.data.total
            this.statusData = this.elseStatusData
          }
        })
      }
    },
    stateFormat(row, column) {
      if (row.approveStatus == 1 || row.checkStatus == 0) {
        return "待审核";
      } else if (row.approveStatus == 2 || row.checkStatus == 1) {
        return "已通过";
      } else if (item.approveStatus == 3 || item.checkStatus == 2) {
        return "已拒绝";
      }
    },
    machineStatusStyle(approveStatus, checkStatus) {
      if (approveStatus == 1 || checkStatus == 0) { // 待审核
        return {background: "#DBEEFF", color: "#258DE9", border: '#DBEEFF'};
      } else if (approveStatus == 2 || checkStatus == 1) { // 已通过
        return {background: "#D6FFE5", color: "#1AE35C", border: '#D6FFE5'};
      } else if (approveStatus == 3 || checkStatus == 2) { // 拒绝
        return {background: "#FFE0DB", color: "#FF5F6D", border: '#FFE0DB'};
      }
    },
  },
  created() {
    this.getDataFn()
  }
}
</script>
<style lang="less" scoped>
.reason {
  font-size: 14px;
  font-weight: 400;
  color: #666666;
}

.el-dropdown-link {
  cursor: pointer;
  color: #409EFF;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.list-left {
  > h5 {
    font-size: 18px;
    font-weight: 500;
    color: #333333;
    line-height: 30px;
  }

  > p:last-child {
    margin-left: 30px;
  }

  > p.date {
    > span:last-child {
      margin-left: 10px;
    }
  }

  > p {
    display: inline-block;

    > span.name {
      color: #333333
    }

    > span {
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      line-height: 40px;
    }
  }
}

.font {
  font-size: 18px;
  font-weight: 500;
  line-height: 70px;
}

.font.pass {
  color: #1A80FC;
}

.font.refuse {
  color: #FF6440;
}

.awit {
  width: 63%;
  height: 32px;
  line-height: 32px;
  padding: 0;
  background: #FF6440;
  border-radius: 4px;
  border: none;
  color: #ffffff;
  font-size: 18px;
  margin-top: 20px;
  position: relative;
  right: 12px;
}

.awit:hover {
  background: transparent;
  border: none;
  background: #FF6440;
  color: #ffffff;

}

// 分页
.nomore {
  line-height: 50px;
  text-align: center;
  margin-top: 24px
}
</style>
